(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // GSAP Glitch Effect for Product Card Images (only if enabled)
  window.initGlitchEffect = function() {
    console.log('initGlitchEffect called');
    
    // Check if GSAP is available
    if (typeof gsap === 'undefined') {
      console.error('GSAP is not loaded yet, retrying in 100ms...');
      setTimeout(window.initGlitchEffect, 100);
      return;
    }
    
    const productGridContainers = document.querySelectorAll('[data-enable-glitch="true"]');
    console.log('Found', productGridContainers.length, 'containers with glitch enabled');
    
    productGridContainers.forEach(productGridContainer => {
      const cardWrappers = Array.from(productGridContainer.querySelectorAll('.card-wrapper, .card'));
      
      // Debug: log if cards are found
      if (cardWrappers.length === 0) {
        console.log('No cards found in container:', productGridContainer);
        return;
      }
      
      // Skip if already initialized (check after we know there are cards)
      if (productGridContainer.dataset.glitchInitialized === 'true') {
        console.log('Container already initialized, skipping');
        return;
      }
      productGridContainer.dataset.glitchInitialized = 'true';
      
      const glitchPercentage = parseInt(productGridContainer.dataset.glitchPercentage) || 100;
      const autoPlay = productGridContainer.dataset.glitchAutoPlay === 'true';
      const intervalMin = parseInt(productGridContainer.dataset.glitchIntervalMin) || 3;
      const intervalMax = parseInt(productGridContainer.dataset.glitchIntervalMax) || 8;
      const glitchIntensity = parseInt(productGridContainer.dataset.glitchIntensity) || 100;
      
      console.log('Initializing glitch for', cardWrappers.length, 'cards with', glitchPercentage, '% coverage');
      
      // Randomly select cards based on percentage
      const numberOfCardsToGlitch = Math.ceil((cardWrappers.length * glitchPercentage) / 100);
      
      // Shuffle cards array and select the first N cards
      const shuffledCards = cardWrappers.sort(() => Math.random() - 0.5);
      const selectedCards = shuffledCards.slice(0, numberOfCardsToGlitch);
      
      selectedCards.forEach(card => {
        let isGlitching = false;
        let autoPlayTimer = null;
        
        // Add a visual indicator class (optional - for debugging)
        card.classList.add('has-glitch-effect');
        
        // Auto-play glitch effect
        if (autoPlay) {
          function scheduleNextGlitch() {
            // Random interval between min and max seconds
            const randomInterval = (Math.random() * (intervalMax - intervalMin) + intervalMin) * 1000;
            
            autoPlayTimer = setTimeout(() => {
              if (!isGlitching) {
                isGlitching = true;
                
                const images = card.querySelectorAll('img');
                if (images.length >= 2) {
                  const img1 = images[0];
                  const img2 = images[1];
                  
                  // Randomly decide direction (forward or reverse)
                  const goForward = Math.random() > 0.5;
                  
                  if (goForward) {
                    imageGlitchTransition(img1, img2, false, glitchIntensity, () => {
                      isGlitching = false;
                      scheduleNextGlitch();
                    });
                  } else {
                    imageGlitchTransition(img2, img1, true, glitchIntensity, () => {
                      isGlitching = false;
                      scheduleNextGlitch();
                    });
                  }
                } else {
                  isGlitching = false;
                  scheduleNextGlitch();
                }
              } else {
                scheduleNextGlitch();
              }
            }, randomInterval);
          }
          
          // Start with a random initial delay
          const initialDelay = Math.random() * intervalMax * 1000;
          setTimeout(scheduleNextGlitch, initialDelay);
          
          // Pause auto-play on hover
          card.addEventListener('mouseenter', function() {
            if (autoPlayTimer) {
              clearTimeout(autoPlayTimer);
              autoPlayTimer = null;
            }
          });
          
          card.addEventListener('mouseleave', function() {
            if (!autoPlayTimer) {
              scheduleNextGlitch();
            }
          });
        }
        
        // Manual hover trigger (always available)
        card.addEventListener('mouseenter', function() {
          if (isGlitching) return;
          isGlitching = true;
          
          const images = this.querySelectorAll('img');
          if (images.length >= 2) {
            const img1 = images[0];
            const img2 = images[1];
            
            imageGlitchTransition(img1, img2, false, glitchIntensity, () => {
              isGlitching = false;
            });
          } else {
            isGlitching = false;
          }
        });
        
        card.addEventListener('mouseleave', function() {
          if (isGlitching) return;
          isGlitching = true;
          
          const images = this.querySelectorAll('img');
          if (images.length >= 2) {
            const img1 = images[0];
            const img2 = images[1];
            
            imageGlitchTransition(img2, img1, true, glitchIntensity, () => {
              isGlitching = false;
            });
          } else {
            isGlitching = false;
          }
        });
      });
    });
    
    function imageGlitchTransition(fromImg, toImg, reverse, intensity, callback) {
      const tl = gsap.timeline({ onComplete: callback });
      
      // Normalize intensity (0-100 scale to multiplier)
      const intensityMultiplier = intensity / 100;
      
      // Blend modes for glitch effect (more dramatic at higher intensities)
      const blendModes = ['difference', 'exclusion', 'screen', 'overlay', 'color-dodge', 'hard-light'];
      
      // Number of frames varies with intensity (4-10 frames for stop-motion feel)
      const baseFrameCount = Math.max(4, Math.min(10, Math.floor(5 + (intensityMultiplier - 0.5) * 5)));
      const frameCount = gsap.utils.random(baseFrameCount, baseFrameCount + 3, 1);
      
      // Scale values based on intensity - more dramatic scaling with randomization
      const xRange = gsap.utils.random(6, 10) * intensityMultiplier;
      const yRange = gsap.utils.random(3, 6) * intensityMultiplier;
      const shadowRange = gsap.utils.random(3, 6) * intensityMultiplier;
      const shadowOpacity = Math.min(1, 0.5 + (0.5 * intensityMultiplier));
      
      // Stop-motion style: quick frame holds with instant cuts - slightly randomized
      const frameDuration = gsap.utils.random(0.03, 0.05); // Varied frame duration for more organic feel
      
      // Randomize color channels for more variety
      const colorChannels = [
        ['rgba(255, 0, 255', 'rgba(0, 255, 255'],  // Magenta & Cyan (classic)
        ['rgba(255, 0, 0', 'rgba(0, 255, 0'],      // Red & Green
        ['rgba(255, 100, 0', 'rgba(0, 100, 255'],  // Orange & Blue
        ['rgba(255, 0, 100', 'rgba(0, 255, 200']   // Pink & Teal
      ];
      const selectedColors = colorChannels[Math.floor(Math.random() * colorChannels.length)];
      
      for (let i = 0; i < frameCount; i++) {
        const progress = i / frameCount;
        const blendMode = blendModes[Math.floor(Math.random() * blendModes.length)];
        
        // Randomly show either image with glitchy offset
        const showFromImage = Math.random() > progress; // Gradually favor toImg
        
        if (showFromImage) {
          // Show from image with glitch offset
          tl.set(fromImg, {
            opacity: 1,
            x: gsap.utils.random(-xRange, xRange),
            y: gsap.utils.random(-yRange, yRange),
            filter: `drop-shadow(${gsap.utils.random(-shadowRange, shadowRange)}px 0 ${selectedColors[0]}, ${shadowOpacity})) drop-shadow(${gsap.utils.random(-shadowRange, shadowRange)}px 0 ${selectedColors[1]}, ${shadowOpacity}))`,
            mixBlendMode: intensity > 80 ? blendMode : 'normal'
          }, i * frameDuration)
          .set(toImg, {
            opacity: 0
          }, i * frameDuration);
        } else {
          // Show to image with glitch offset
          tl.set(toImg, {
            opacity: 1,
            x: gsap.utils.random(-xRange, xRange),
            y: gsap.utils.random(-yRange, yRange),
            filter: `drop-shadow(${gsap.utils.random(-shadowRange, shadowRange)}px 0 ${selectedColors[0]}, ${shadowOpacity})) drop-shadow(${gsap.utils.random(-shadowRange, shadowRange)}px 0 ${selectedColors[1]}, ${shadowOpacity}))`,
            mixBlendMode: intensity > 80 ? blendMode : 'normal'
          }, i * frameDuration)
          .set(fromImg, {
            opacity: 0
          }, i * frameDuration);
        }
      }
      
      // Final frame: clean settle on target image
      tl.set(toImg, {
        opacity: 1,
        x: 0,
        y: 0,
        filter: 'none',
        mixBlendMode: 'normal'
      }, frameCount * frameDuration)
      .set(fromImg, {
        opacity: 0,
        x: 0,
        y: 0,
        filter: 'none',
        mixBlendMode: 'normal'
      }, frameCount * frameDuration);
    }
    
    // Initialize soft fade for cards without glitch effect
    const allCardWrappers = document.querySelectorAll('.card-wrapper, .card');
    allCardWrappers.forEach(card => {
      // Skip if this card has glitch effect
      if (card.classList.contains('has-glitch-effect')) return;
      
      const images = card.querySelectorAll('img');
      if (images.length >= 2) {
        const img1 = images[0];
        const img2 = images[1];
        
        // Set initial state
        gsap.set(img1, { opacity: 1 });
        gsap.set(img2, { opacity: 0 });
        
        // Fade on hover
        card.addEventListener('mouseenter', function() {
          gsap.to(img1, { opacity: 0, duration: 0.4, ease: 'power2.inOut' });
          gsap.to(img2, { opacity: 1, duration: 0.4, ease: 'power2.inOut' });
        });
        
        card.addEventListener('mouseleave', function() {
          gsap.to(img1, { opacity: 1, duration: 0.4, ease: 'power2.inOut' });
          gsap.to(img2, { opacity: 0, duration: 0.4, ease: 'power2.inOut' });
        });
      }
    });
  }

  // Initialize glitch effect when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initGlitchEffect);
  } else {
    window.initGlitchEffect();
  }

  } catch(e) { console.error(e); }
})();
})();
